module.exports = "/_next/static/images/metrologo-e0943aa0233a8c09918ae1c21a238ad3.png";